<template>
  <div class="no-gutters align-items-top justify-content-center" v-if="resultsFound()">
    <!-- div class="row no-gutters col-lg align-items-top justify-content-center sort-by-box" -->
    <div role="region" aria-label="Search results" class="row no-gutters result-count-sort-box">
      <div class="col-lg result-count-div">
        <h2 id="search-results-header" role="status">{{ resultsHeader }}</h2>
      </div>
      <!-- div class="row no-gutters col-lg-8 align-items-top justify-content-center" -->
      <div class="col-lg-6">
        <div class="row no-gutters">
          <div class="col-md result-orderby-text-div">
            <!-- label class="label" for="search-text">{{ $t('search.form.option') }}</label -->
            <label class="label" for="order-option">{{ $t('search.results.orderBy') }}</label>
          </div>
          <div class="col-lg">
            <select class="form-control facets" style="min-width: 260px;" v-model="orderBy" id="order-option" @change="handleClick" >
              <option selected="true" value="default">{{ $t('search.results.relevance') }}</option> 
              <option value="app-num">{{ $t('search.results.applicationNumber') }}</option> 
              <option value="app-status">{{ $t('search.results.appStatus') }}</option> 
              <option value="app-addr">{{ $t('search.results.addressFriendly') }}</option> 
              <option value="app-type">{{ $t('search.results.applicationType') }}</option> 
              <option value="rev-status">{{ $t('search.results.currentStatus') }}</option> 
              <option value="dt-status">{{ $t('search.results.date') }}</option> 
            </select>
          </div>  
          <div class="col-lg">
            <select class="form-control facets" style="min-width: 145px;" v-model="orderType" id="order-type" @change="handleClick" v-show="notOrderByRel()">
              <option selected="true" value="asc">{{ $t('search.results.ascending') }}</option> 
              <option value="desc">{{ $t('search.results.descending') }}</option> 
            </select>
          </div>
        </div>
      </div>
    </div>
    <div>
      <table class="res-table">
        <thead class="res-thead">
          <tr>
            <th scope="col" class="res-th">{{ $t('search.results.applicationNumber') }}</th>
            <th scope="col" class="res-th">{{ $t('search.results.appStatus') }}</th>
            <th scope="col" class="res-th">{{ $t('search.results.addressFriendlyPlural') }}</th>
            <th scope="col" class="res-th">{{ $t('search.results.applicationType') }}</th>
            <th scope="col" class="res-th">{{ $t('search.results.currentStatus') }}</th>
            <th scope="col" class="res-th">{{ $t('search.results.date') }}</th>
          </tr>
        </thead>
        <tbody  class="res-tbody">
          <tr class="res-tr" v-for="devapp in results" :key="devapp.devAppId">
            <td scope="row" v-bind:class="{'res-td-fr':(curLang ==='fr'), 'res-td':(curLang ==='en'), 'app-num':true}">
              <a href="#"
                v-bind:id="'btn_more_info_' + devapp.devAppId"
                v-bind:aria-label="getMoreButtonText(devapp)"
                v-on:click.prevent="viewDevappDetails(devapp)"
              >{{ devapp.applicationNumber }}</a>
            </td>
            <td v-bind:class="{'res-td-fr':(curLang ==='fr'), 'res-td':(curLang ==='en'), 'app-status':true }">
              <!-- <span v-if="devapp.applicationStatus['en']=='Active' || devapp.applicationStatus['en']=='File Pending'">{{ $t('search.results.canComment') }}</span><span v-else>{{ $t('search.results.cannotComment') }}</span>
              ({{ devapp.applicationStatus[curLang] }}) -->
              {{ devapp.applicationStatus[curLang] }}
            </td>
            <td v-bind:class="{'res-td-fr':(curLang ==='fr'), 'res-td':(curLang ==='en'), 'app-addr':true }">
              <span v-if="noAddressAttached(devapp)"> - </span>
              <span v-else-if="devapp.devAppAddresses.length > 1">
                <!--li v-for="address in devapp.devAppAddresses" :key="devapp.devAppId + address.addressReferenceId + '-' + address.parcelPinNumber">{{ address.addressNumberRoadName }} </li -->
                <span v-for="address in getUniqueAddresses(devapp)" :key="address.id">{{ address.streetAddress }} <br /></span>
              </span>
              <span v-else>
                <span v-if="devapp.devAppAddresses[0].addressNumberRoadName">{{ devapp.devAppAddresses[0].addressNumberRoadName }}</span>
                <span v-else-if="devapp.devAppAddresses[0].municipality">{{ devapp.devAppAddresses[0].municipality }}</span>
              </span>
            </td>
            <td v-bind:class="{'res-td-fr':(curLang ==='fr'), 'res-td':(curLang ==='en')}">{{ devapp.applicationType[curLang] }}</td>
            <td v-bind:class="{'res-td-fr':(curLang ==='fr'), 'res-td':(curLang ==='en')}">{{ devapp.objectStatus.objectCurrentStatus[curLang] }}</td>
            <td v-bind:class="{'res-td-fr':(curLang ==='fr'), 'res-td':(curLang ==='en'), 'status-dt':true }">{{ devapp.objectStatus.objectCurrentStatusDateYMD }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div>
      <div class="search-results-page-actions clearfix">
        <button v-show="showPrevious()" id='btn-previous' class="btn-sm btn-primary"
          v-bind:aria-label="$t('search.results.previousPage')"
          v-on:click.prevent="fetchPreviousResultSet()">
          {{ $t('search.results.previousPage') }}
        </button>
        <button v-show="showNext()" id='btn-next' class="btn-sm btn-primary"
          v-bind:aria-label="$t('search.results.nextPage')"
          v-on:click.prevent="fetchNextResultSet()">
          {{ $t('search.results.nextPage') }}
        </button>
      </div>
    </div>
    <div id="default-map-container" class="devapp-map-area" v-bind:style="{ height: mapHeight }">
      <map-view v-on:update-map="$emit('update-map')"></map-view>
    </div>
  </div>
  <div class="no-gutters justify-content-center" v-else>
    <div class="row justify-content-center align-items-middle no-result-msg" role="status" v-bind:style="{ height: noResultMsgHeight }"><p>{{ resultsHeader }}</p></div>
  </div>
</template>

<script>
import MapView from '@/components/MapView.vue'
import { getEmptyAddress } from '@/util/api'

export default {
  name: 'search-results',
  data: function() {
    return {
      loading: true,
      results: [ ],
      curLang: this.$i18n.currentLanguage(),
      recCount: 0,
      contentHeight: 0,
      mapHeight: 0,
      noResultMsgHeight: 0,
      orderBy: this.$store.state.orderBy,
      orderType: this.$store.state.orderType
    }
  },
  components: {
    MapView,
  },
  props: {
    renderTime: Number
  },
  methods: {
    getResultLimit: function() {
      let limit = 0;
      const storedResults = this.$store.state.searchResults;
      
      if(process.env.VUE_APP_RESULT_LIMIT) {
        limit = parseInt(process.env.VUE_APP_RESULT_LIMIT)
        //console.log('Results limit found: ' + limit)
      } else if(storedResults && storedResults.limit ) {
        //console.log('Results limit found in search results: ' + limit)
        limit = parseInt(storedResults.limit)
      }
      return limit;
    },
    fetchNextResultSet: function() {
      const storedResults = this.$store.state.searchResults;
      const limit = this.getResultLimit()
      let idx = 0;
      //console.log('Next click', storedResults.totalDevApps, (storedResults.index + limit))
      if( storedResults && storedResults.totalDevApps > (storedResults.index + limit)) {
        idx = storedResults.index + limit
        this.$store.commit('searchIndex', idx);
        this.$emit('fetch-next-resultset');
      }
    },
    fetchPreviousResultSet: function() {
      const storedResults = this.$store.state.searchResults;
      const limit = this.getResultLimit()
      let idx = 0;
      //console.log('Previous click', storedResults.index, limit)
      if( storedResults && storedResults.index >= limit ) {
        idx = storedResults.index - limit
        this.$store.commit('searchIndex', idx);
        this.$emit('fetch-next-resultset');
      }
    },
    showNext: function() {
      const storedResults = this.$store.state.searchResults;
      const limit = this.getResultLimit()
      let idx = 0;
      if( storedResults ) {
        idx = storedResults.index + limit
        //console.log('next button show check', idx, storedResults.totalDevApps)
        return (storedResults.totalDevApps > idx);
      }
      return false;
    },
    showPrevious: function() {
      const storedResults = this.$store.state.searchResults;
      const limit = this.getResultLimit()
      let idx = 0;
      if( storedResults ) {
        idx = storedResults.index
      }
      //console.log('previous button show check', idx, limit)
      return (idx >= limit);
    },
    resultsFound: function() {
      const storedResults = this.$store.state.searchResults;
      if( storedResults && storedResults.devApps && storedResults.devApps.length > 0 ) {
        return true;
      }
      return false;
    },
    handleClick: function() {
      this.$store.commit('orderBy',this.orderBy);
      this.$store.commit('orderType',this.orderType);
      this.$store.commit('searchIndex', 0);
      //console.log('SearchResult.vue - handleClick()')
      this.$emit('order-resultset');
    },
    noAddressAttached: function(devapp) {
      if( devapp ) {
        if( devapp.devAppAddresses && devapp.devAppAddresses.length >= 1) {
          return false;
        }
        return true;
      }
      return true;
    },
    getUniqueAddresses: function(devapp) {
      let addresses = [];

      if( devapp.devAppAddresses == null || devapp.devAppAddresses.length == 0) {
        //console.log('Addresses not found');
        return addresses;
      }

      //console.log('Addresses:', devapp.devAppAddresses);

      let streetAddress = '';
      for (let addrId in devapp.devAppAddresses) {
        let addr = devapp.devAppAddresses[addrId]
        //console.log('DEBUG', 'Last I am here');
        //console.log('addr:', addr);

        if( addr != null && addr.addressNumberRoadName != null) {
          if( addr.addressNumberRoadName != streetAddress ) {
            streetAddress = addr.addressNumberRoadName;
            let newAddr = getEmptyAddress();
            newAddr.id = devapp.devAppId + addr.addressReferenceId + '-' + addr.parcelPinNumber;
            newAddr.streetAddress = streetAddress;
            newAddr.streetType = addr.roadType;
            addresses.push(newAddr)
          }
        }
      }

      return addresses;
    },
    getMoreButtonText: function(devapp) {
      let text = this.$t('search.results.moreButtonAriaLabel');
      //console.log('1:', text);

      text = text.replace('_APP_NUM_', devapp.applicationNumber);

      //console.log('2:', text);
      return text;
    },
    viewDevappDetails: function(devapp) {
      // Find the original geo JSON object for the specified devapp
      //let geoDevapp = findDevAppById(devapp.devAppId)
      let tempDevApp = null
      const storedResults = this.$store.state.searchResults
      if (storedResults && storedResults.devApps) {
        // Iterate over the raw results, and modify some properties.
        const devApps = storedResults.devApps
        for (let devAppId in devApps) {
          tempDevApp = devApps[devAppId]
          if(tempDevApp.devAppId == devapp.devAppId){
            break
          }
        }
      }

      this.$store.commit('currentDevapp', tempDevApp)
      this.$router.push({
        name: 'DevappDetails',
        params: {
          //id: devapp.devAppId
          id: devapp.applicationNumber
        }
      })
    },
    notOrderByRel: function() {
      if( this.orderBy == 'default')
        return false;
      else
        return true;
    },
    resizeElements: function() {
      this.contentHeight = (window.innerHeight * 0.65) + 'px'
      this.mapHeight = this.contentHeight;
      this.noResultMsgHeight = (window.innerHeight * 0.5) + 'px'
      if (window.innerHeight <= 768) {
        this.contentHeight = (window.innerHeight * 1.5) + 'px'
        this.noResultMsgHeight = (window.innerHeight * 1) + 'px'
      }
    }
  },
  mounted: function() {
    this.resizeElements()
  },
  computed: {
    searchResults: function() {
      let results = [ ]
      const storedResults = this.$store.state.searchResults
      if (storedResults && storedResults.devApps) {
        // Iterate over the raw results, and modify some properties.
        //const devApps = storedResults.devApps
        results = storedResults.devApps
        //for (let devAppId in devApps) {
        //  let devapp = devApps[devAppId]
          //console.log(devapp)
        //  results.push(devapp)
        //}
        /*
        // Apply sorting
        results.sort((a, b) => {
          const aKey = a.applicationNumber
          const bKey = b.applicationNumber
          if (aKey < bKey) { return -1 }
          if (aKey > bKey) { return 1 }
          return 0
        })
        */
      }
      return results
    },
    resultsHeader: function () {
      let headerText = this.$t('search.results.loading')
      const storedResults = this.$store.state.searchResults;
      const limit = this.getResultLimit();
      let rangeText = ''
      let idx = 0;
      
      if( storedResults && storedResults.totalDevApps > limit ) {

        idx = storedResults.index

        if( (idx + limit) > storedResults.totalDevApps ) {
          rangeText = (idx + 1) + '-' + storedResults.totalDevApps
        } else {
          rangeText = (idx + 1) + '-' + (idx + limit)
        }

        rangeText = rangeText + ' ' + this.$t('search.results.of') + ' '
        //console.log( idx, limit, storedResults.totalDevApps, rangeText)
      }

      if (!this.loading) {
        let count = 0
        const storedResults = this.$store.state.searchResults
        if (storedResults && storedResults.devApps) {
          count = storedResults.totalDevApps
        }
        //headerText = `${count} ${this.$t('search.results.header')} "${this.$store.state.searchText}"`
        if( count > 0)
          headerText = rangeText + `${count} ${this.$t('search.results.header')}`
        else
          headerText = this.$t('search.results.noResults');
      }
      return headerText
    },
  },
  watch: {
    searchResults: function(newValue) {
      // Don't bind the search results DOM elements directly, so we can start
      // with an empty page in case where search results already existed.
      this.results = newValue
      this.loading = false
    }
  },
  created: function() {
    // If we arrived here via a means other than the search button or direct URL,
    // trigger a refresh manually (since the search results won't change thus
    // triggering the watcher)
    this.results = this.searchResults
    this.loading = false
    //console.log('created', 'here first')
  },
  updated: function() {
    if(this.results && this.results.length > 0 ) {
      let el = document.getElementById('search-text')
      //let el = document.getElementById('search-results-header-div')
      if( el ) {
        el.focus()
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/app.scss';
</style>
